import styled from "@emotion/styled";
import ArrowNext from "@engineering/icons/arrow-next";
import { InteractiveText } from "@silvertours/front-shared";
export var Anchor = /*#__PURE__*/ styled("a", {
    target: "e18ucdct0"
})("display:flex;justify-content:space-between;color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";text-decoration:none;&:hover{color:", function(param) {
    var theme = param.theme;
    return theme.color.primary70;
}, ";}");
export var Text = /*#__PURE__*/ styled(InteractiveText, {
    target: "e18ucdct1"
})("margin-right:", function(param) {
    var theme = param.theme;
    return theme.spacing[60];
}, ";");
export var ArrowNextIcon = /*#__PURE__*/ styled(ArrowNext, {
    target: "e18ucdct2"
})("height:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";width:", function(param) {
    var theme = param.theme;
    return theme.spacing[50];
}, ";flex-shrink:0;fill:currentcolor;");
